const appKey = "tdw2023"
const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: "TDW 2023",
    description:
      "沙龙活动的主要出发点，还是想要邀请游戏开发者们聚在一起，纯粹的对游戏创作过程中，进行交流和分享，同时每年也希望能跟开发者们同步一下 TapTap接下来的重点方向，也想听取开发者们对于TapTap产品本身的一些意见和建议。",
    shareTitle: "TDW 2023",
    shareDescription: "TapTap开发者沙龙",
  },
  data: {
    workStreamingUrl:
      "https://www.bilibili.com/blackboard/live/live-activity-player.html?cid=25613406&quality=0",
    // workStreamingUrl:
    //   "https://tools.liumingye.cn/m3u8/#https://live.taptap.com/TapLive/2023TDS.m3u8?auth_key=1691160045-0-0-ef3b00428208e1ca2769e4888feb67e7",
    taptapUrl: "https://www.taptap.com/",
    devCenterUrl: "https://developer.taptap.com/",
    devDocUrl: "https://developer.taptap.com/docs/",
    devForumUrl: "https://www.taptap.com/forum/g28",
  },
}
